import pageRoutes from './page.routes';

import pageController from './controllers/page.controller';
import messageController from './controllers/message.controller';
import availabilitySliderController from './controllers/availabilitySlider.controller';
import searchFormController from './controllers/searchForm.controller';
import selectTypeController from './controllers/selectType.controller';
import quickBookController from './controllers/quickBook.controller';

import messageComponent from './components/message.component';
import iconComponent from './components/icon.component';
import spinnerComponent from './components/spinner.component';
import loadingComponent from './components/loading.component';
import availabilitySliderComponent from './components/availabilitySlider.component';
import searchFormComponent from './components/searchForm.component';
import selectTypeComponent from './components/selectType.component';
import quickBookComponent from './components/quickBook.component';

import requiredDirective from './directives/required.directive';
import formFieldErrorsDirective from './directives/formFieldErrors.directive';
import disabledDirective from './directives/disabled.directive';

import messageService from './services/message.service';
import contentService from './services/content.service';
import markdownService from './services/markdown.service';
import loginoutService from './services/loginout.service';
import urlService from './services/url.service';
import eventService from './services/event.service';
import propertyService from './services/property.service';

let pageModule = angular.module('spabooker.page', ['ui.select'])
    .config(pageRoutes)

    .controller('pageController', pageController)
    .controller('messageController', messageController)
    .controller('availabilitySliderController', availabilitySliderController)
    .controller('searchFormController', searchFormController)
    .controller('selectTypeController', selectTypeController)
    .controller('quickBookController', quickBookController)

    .component('message', messageComponent)
    .component('icon', iconComponent)
    .component('spinner', spinnerComponent)
    .component('loading', loadingComponent)
    .component('availabilitySlider', availabilitySliderComponent)
    .component('searchForm', searchFormComponent)
    .component('selectType', selectTypeComponent)
    .component('quickBook', quickBookComponent)

    .directive('required', requiredDirective)
    .directive('formFieldErrors', formFieldErrorsDirective)
    .directive('a', disabledDirective)

    .factory('messageService', messageService)
    .factory('contentService', contentService)
    .factory('markdownService', markdownService)
    .factory('loginoutService', loginoutService)
    .factory('urlService', urlService)
    .factory('eventService', eventService)
    .factory('propertyService', propertyService)
    ;
export default pageModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/index.js